import * as React from 'react';
import classNames from 'classnames';

import SVGDynamicIcon from 'components/svg-dynamic-icon/SVGDynamicIcon';
import MediaPreview from 'components/MediaPreview';
import RealmOutfitItemForm from '../realm-outfit-item-form/RealmOutfitItemForm';

import { __t, applyTranslations } from 'utils/language';

import { RealmOutfitItem, RealmOutfitItemResource } from 'types';

import './outfit-items.scss';

applyTranslations(require('./outfit-items.i18n.json'));

interface Props {
  items: Array<RealmOutfitItem | RealmOutfitItemResource>,
  editMode: 'edit' | 'remove-only' | 'none',
  onAddNew: (item: RealmOutfitItemResource) => void,
  onDeleteItem: (sku: string, id: number) => void,
  title?: string,
  hasSimilarItem?: boolean
}

const OutfitItems = ({
  hasSimilarItem = true,
  title,
  items,
  editMode,
  onAddNew,
  onDeleteItem
}: Props): JSX.Element | null => {
  const renderRealmItemDetails = (
    outfitItem: RealmOutfitItem | RealmOutfitItemResource
  ): JSX.Element | null => {
    if (!outfitItem.itemUrl) {
      return null;
    }
    return (
      <div
        className="outfit-items__item-label-container"
        onClick={event => {
          event.stopPropagation();

          window.open(outfitItem.itemUrl, '_blank');
        }}
      >
        <div className="text-overflow-ellipsis outfit-items__item-label-btn">
          {hasSimilarItem ?
            __t(`outfit_items.item.${outfitItem.isSimilar ? 'similar' : 'exact'}`) : outfitItem.sku}
        </div>
      </div>
    );
  };

  const itemClasses = classNames('outfit-items__preview', {
    'outfit-items__preview--edit': editMode !== 'none'
  });

  return (
    <div>
      {
        items.length ? (
          <React.Fragment>
            <div className="outfit-items__item-heading">
              {__t('outfit_items.label_items')}
            </div>
            <div className="outfit-items__items">
              {
        items.map(item => {
          const attachment = {
            id: item.id,
            url: item.imageUrl,
            assetType: 'image',
            format: 'image',
            meta: {
              type: 'highres'
            }
          };

          return (
            <div
              key={`SKU-${item.sku}`}
              className="outfit-items__item"
            >
              <MediaPreview
                className={itemClasses}
                attachment={attachment}
                width={120}
                height={120}
              />
              {
                editMode !== 'none' && (
                  <div className="outfit-items__delete-icon">
                    <SVGDynamicIcon
                      height={16}
                      width={16}
                      name="trash-custom-fg"
                      clickable
                      onClick={() => onDeleteItem(item.sku, item.id)}
                      customColor="grey"
                    />
                  </div>
                )
              }
              {renderRealmItemDetails(item)}
            </div>
          );
        })
      }
            </div>
          </React.Fragment>

        ) : null
      }
      {
        editMode === 'edit' && (
          <div>
            <RealmOutfitItemForm
              hasSimilarItem={hasSimilarItem}
              title={title}
              onSubmit={onAddNew}
            />
          </div>
        )
      }
    </div>

  );
};

export default OutfitItems;
